import { useMediaQuery, useTheme } from '@mui/material';

export const useScreenSize = () => {
  const theme = useTheme();

  return {
    xs: useMediaQuery(theme.breakpoints.only('xs')),
    sm: useMediaQuery(theme.breakpoints.only('sm')),
    md: useMediaQuery(theme.breakpoints.only('md')),
    lg: useMediaQuery(theme.breakpoints.only('lg')),
    xl: useMediaQuery(theme.breakpoints.only('xl')),
    smAndDown: useMediaQuery(theme.breakpoints.down('sm')),
    mdAndDown: useMediaQuery(theme.breakpoints.down('md')),
    lgAndDown: useMediaQuery(theme.breakpoints.down('lg')),
    xlAndDown: useMediaQuery(theme.breakpoints.down('xl')),
    smAndUp: useMediaQuery(theme.breakpoints.up('sm')),
    mdAndUp: useMediaQuery(theme.breakpoints.up('md')),
    lgAndUp: useMediaQuery(theme.breakpoints.up('lg')),
    xlAndUp: useMediaQuery(theme.breakpoints.up('xl')),
  };
};
